var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mediclist"},[_c('div',{staticClass:"big-top"},[_vm._v("1")]),_c('div',{staticClass:"big-content"},[_c('div',{staticClass:"big-content-left"},[_vm._v("2")]),_c('div',{staticClass:"big-content-main"},[_vm._v("3")]),_c('div',{staticClass:"big-content-right"},[_vm._v("4")])])])
}]

export { render, staticRenderFns }